export const specialCh = "() !#$*`\\|%&+,;=?@\\[\\]\"':<>";
